$(".twocol .gpvideoblock, .video-list, .mixcontent-video-wrap").each(function () {
    const videoWrap = $(this);
    const video = videoWrap.find('a.gpLocalVideo, a.video-list-video, a.mixcontent-video');
    const thisVideoSrc = video.data('src');

    video.each(function () {
        const video = $(this);
        const thisInner = video.html();
    
        // Set attributes
        classAttributes = `${video.attr('class') && `class="${video.attr('class')}"`}`;
        dataAttributesSrc = `${video.data('mfp-src') && `data-mfp-src="${video.data('mfp-src')}"`}`;
        // Apply attributes
        const buttonAttributes = `${classAttributes} ${dataAttributesSrc}`;
    
        // Construct and replace with button
        video.replaceWith('<button '+buttonAttributes+'>'+thisInner+'</button>');
    });
});